import { useState } from 'react';
import type { User, TokenUsage } from '../types';
// API key management removed — no client-side key deletion

interface HeaderProps {
  user: User | null;
  onLogout: () => void;
  step: string;
  onGoHome: () => void;
  tokenUsage?: TokenUsage;
  contextPercentage?: number;
  onResetUsage?: () => void;
}

export default function Header({ user, onLogout, step, onGoHome }: HeaderProps) {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const STEP_LABELS: Record<string, string> = {
    upload: 'Upload Text',
    analyzing: 'Analyzing...',
    select: 'Select Words',
    format: 'Choose Format',
    artifact: 'Your Artifact',
  };

  return (
    <header className="app-header">
      <div className="header-left">
        <button className="logo-btn" onClick={onGoHome} aria-label="Go to home">
          <span className="logo-mark">V</span>
          <span className="logo-text">Vocabulizer</span>
        </button>
        {step && step !== 'upload' && (
          <span className="breadcrumb">
            <span className="breadcrumb-sep">›</span>
            <span className="breadcrumb-step">{STEP_LABELS[step] || step}</span>
          </span>
        )}
      </div>

      {user && (
        <div className="header-right">
          <button
            className="user-btn"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-haspopup="true"
            aria-expanded={menuOpen}
          >
            {user.picture ? (
              <img
                src={user.picture}
                alt={user.name}
                className="avatar"
                referrerPolicy="no-referrer"
              />
            ) : (
              <span className="avatar-fallback">{user.name?.[0] || '?'}</span>
            )}
            <span className="user-name">{user.name}</span>
            <span className="chevron">{menuOpen ? '▲' : '▼'}</span>
          </button>

          {menuOpen && (
            <div className="user-menu" role="menu">
              <div className="user-menu-email">{user.email}</div>
              <hr className="menu-divider" />
              <button
                role="menuitem"
                className="menu-item menu-item-danger"
                onClick={() => {
                  setMenuOpen(false);
                  onLogout();
                }}
              >
                Sign Out
              </button>
            </div>
          )}
        </div>
      )}
    </header>
  );
}
